import { QueryHandler } from '@/redux/types/query-handler';
import { dispatchOptimisticPatchUpdateWellbeingCheckSettings } from './dispatch-optimistic-patch';
import { UpdateWellbeingCheckSettingsQueryArg } from '../types/query-arg';

export const handleResultUpdateWellbeingCheckSettings: QueryHandler<
  UpdateWellbeingCheckSettingsQueryArg,
  void
> = async (queryArg, { dispatch, getState, queryFulfilled }) => {
  const { patch } = dispatchOptimisticPatchUpdateWellbeingCheckSettings(
    queryArg,
    {
      dispatch,
      getState,
    },
  );

  try {
    await queryFulfilled;
  } catch (err) {
    patch.undo();
    throw err;
  }
};
